<template>
  <div class="vcv-counter">
    <div class="vcv-counter__button" :class="{ disabled: value <= minValue }" @click="minus">-</div>
    <input
      class="vcv-counter__input"
      :value="value"
      :style="{ width: inputWidth + 'px' }"
      @input="changeNumber"
      @keypress="numbersOnly"
    />
    <div class="vcv-counter__button" :class="{ disabled: value >= maxValue }" @click="plus">+</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },

    minValue: {
      type: Number,
      default: 0
    },

    maxValue: {
      type: Number,
      default: 12
    },

    inputWidth: {
      type: Number,
      default: 25
    },

    step: {
      type: Number,
      default: 1
    }
  },

  methods: {
    async changeNumber(event) {
      const newValue = Number(event.target.value);
      let clampedValue = Math.min(newValue, this.maxValue);

      if (event.target.value.length === 0 || newValue < this.minValue) {
        clampedValue = this.minValue;
      }

      this.$emit('input', newValue);
      await this.$nextTick();
      this.$emit('input', clampedValue);
    },

    numbersOnly(event) {
      const evt = event ? event : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    minus() {
      if (this.value < this.minValue + 1) {
        this.$emit('input', this.minValue);
      } else {
        this.$emit('input', this.value - this.step);
      }
    },

    plus() {
      if (this.value > this.maxValue - 1) {
        this.$emit('input', this.maxValue);
      } else {
        this.$emit('input', this.value + this.step);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vcv-counter {
  display: inline-flex;
  align-items: center;
  margin: 0 7px;

  &__input {
    margin: 0 5px;
    height: 20px !important;
    font-size: 12px;
    border: none;
    background: transparent;
    border-bottom: 1px solid #ccc;
    padding: 0;
    text-align: center;
    color: $main-dark;
  }

  &__button {
    font-size: 16px;
    font-weight: 300;
    color: $main-dark;
    cursor: pointer;

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
}
</style>
